"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");

var _index2 = require("../../../../utils/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : TAB HEAD : STYLES--------------- ++++++++++ */


var _default = {
  tabhead: {
    background: _index.theme.color.light.light.swatch,
    borderRadius: (0, _index.pxToEm)(4),
    border: (0, _index.replacePXinStringWithEM)("1px solid #ECF0F7"),
    boxShadow: (0, _index.replacePXinStringWithEM)("0 1px 1px 0 #EDF1FA"),
    cursor: 'pointer',
    width: (0, _index.pxToEm)(171),
    height: (0, _index.pxToEm)(127),
    margin: (0, _index.replacePXinStringWithEM)('0 20px 20px 0'),
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    zIndex: '2',
    // tab children
    '& .tabtitle': {
      fontSize: (0, _index.pxToEm)(14),
      '&:after': {
        extend: _index.imageTypes.graphic,
        content: '" "',
        display: 'block',
        margin: (0, _index.replacePXinStringWithEM)("".concat((0, _index.pxToEm)(10), " auto 0")),
        width: (0, _index.pxToEm)(42),
        height: (0, _index.pxToEm)(42)
      }
    },
    '& .tabdivider': {
      background: 'transparent',
      border: (0, _index.replacePXinStringWithEM)("1px solid transparent"),
      width: (0, _index.pxToEm)(171),
      height: (0, _index.pxToEm)(23),
      position: 'absolute',
      bottom: (0, _index.pxToEm)(-21),
      left: (0, _index.pxToEm)(-1)
    },
    // last tab
    '&:last-child': {
      marginRight: '0'
    },
    // unique tabs
    '&#websitecode': {
      '& .tabtitle': {
        '&:after': {
          backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/icon-code.png)")
        }
      }
    },
    '&#instantarticle': {
      '& .tabtitle': {
        '&:after': {
          backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/icon-facebook.png)")
        }
      }
    },
    '&#dfp': {
      '& .tabtitle': {
        '&:after': {
          backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/icon-dfp.png)")
        }
      }
    },
    '&#amp': {
      '& .tabtitle': {
        '&:after': {
          backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/icon-amp.png)")
        }
      }
    },
    '&#inapp': {
      '& .tabtitle': {
        '&:after': {
          backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/icon-inapp.png)")
        }
      }
    },
    // on states
    '&.on': {
      borderColor: _index.theme.color.primary.light.swatch,
      borderBottom: '0',
      '& .tabdivider': {
        background: _index.theme.color.light.light.swatch,
        borderColor: _index.theme.color.primary.light.swatch,
        borderTop: '0',
        borderBottom: '0'
      }
    }
  }
};
exports.default = _default;